import { DEFAULT_FORMAT, DEFAULT_FORMAT_WITH_TIME, DEFAULT_FORMAT_WITH_TIME_FOR_FILE_NAME, DEFAULT_CONFIG } from '@/services/date-service';
import $i18n from '@/language/i18n';

export default {
  /**
   * @param withTime {boolean}
   * @returns {string}
   */
  getLocalDateTimeStringNow(withTime = true) {
    const today = new Date();

    if (!withTime) { return this.formatDate(today) }
    return this.formatDate(today, DEFAULT_FORMAT_WITH_TIME);
  },
  getLocalDateTimeStringNowForFileName() {
    const today = new Date();
    return this.formatDate(today, DEFAULT_FORMAT_WITH_TIME_FOR_FILE_NAME);
  },

  /**
   * @param date {Date}
   * @param formatPattern {string}
   * @param config {object}
   * @returns {string}
   */
  formatDate(date, formatPattern = DEFAULT_FORMAT, config = DEFAULT_CONFIG) {
    return _fillDatePatternWithValues(formatPattern, _getPartsOfDate(date, config));
  },

  /**
   * @param date {string|number}
   * @returns {string}
   */
  formatDateToLocaleDateStringNoTime(date) {
    if (!date) { return '' }
    return _formatJsDateToLocaleDateString(date, false);
  },

  /**
   * @param date {string|number}
   * @param withTime {boolean|null}
   * @returns {string}
   */
  formatDateToLocaleDateString(date, withTime = null) {
    if (!date) { return '' }
    const formatWithTime = withTime ?? _dateHasTime(date) ?? false;

    return _formatJsDateToLocaleDateString(date, formatWithTime);
  },

  /**
  * @param date {string|number}
  * @param withTime {boolean|null}
  * @returns {string}
  */
  formatDateToLocaleDateStringMessages(date, withTime = null) {
    if (!date) return '';
    const formatWithTime = withTime ?? _dateHasTime(date) ?? false;

    let result = _formatJsDateToLocaleDateString(date, formatWithTime);
    if (formatWithTime != false) result = result.substring(0, result.length - 3);

    let now = _fillDatePatternWithValues(DEFAULT_FORMAT, _getPartsOfDate(new Date(), DEFAULT_CONFIG));
    let dateWithOutTime = date.substring(0, 10);
    if (now == dateWithOutTime)
      return result.substring(12, result.length);

    return result;
  },

  /**
   * @param date {string}
   * @returns {string}
   */
  formateLocaleStringToDate(date) {
    if (!date) return '';
    const [day, month, year] = date.split('.');
    return new Date([year, month, day].join('-'));
  },

  /**
   * nur für Uhrzeiten verwenden!
   * @param timeInMinutes {number}
   * @returns {string}
   */
  formatMinutesToWorkingHours(timeInMinutes) {
    if (!timeInMinutes) return '';

    var isNegative = false;
    if (timeInMinutes < 0) {
      isNegative = true;
    }

    timeInMinutes = Math.abs(timeInMinutes);

    var hours = Math.trunc(timeInMinutes / 60);
    var minutes = (timeInMinutes % 60).toFixed(0);
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (isNegative) {
      return '-' + hours + ':' + minutes;
    }

    return hours + ':' + minutes;
  },

  /**
   * @param workingHours {string}
   * @returns {number|undefined}
   */
  formatFormattedWorkingHoursToMinutes(workingHours) {
    if (!workingHours) return undefined;
    const parts = workingHours.split(':');
    return (parseInt(parts[0]) * 60) + parseInt(parts[1]);
  },

  daysSinceDate(date) {
    if (!date) {
      return "";
    }
    const date_1 = new Date(date);
    date_1.setUTCHours(0, 0, 0, 0);
    const date_2 = new Date();
    date_2.setUTCHours(0, 0, 0, 0);

    const days = (date_2, date_1) => {
      const difference = date_1.getTime() - date_2.getTime();
      const TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
      return TotalDays;
    }
    return days(date_1, date_2) + "";
  }
};

/**
 * @param date {string|number|Date}
 * @returns {null|boolean}
 * @private
 */
const _dateHasTime = (date) => {
  if (typeof date === 'string') {
    return date.split(' ').length > 1;
  }
  return null;
}

/**
 * @param date {string|number}
 * @param withTime {boolean}
 * @returns {string}
 * @private
 */
const _formatJsDateToLocaleDateString = (date, withTime) => {
  return $i18n.d(_getJsDateOf(date), withTime ? 'long' : 'short');
}

/**
 * @param date {string|number|Date}
 * @returns {Date}
 * @private
 */
const _getJsDateOf = (date) => {
  if (date instanceof Date) { return date }
  return new Date(date);
}

/**
 * @param date {Date}
 * @param config {Object}
 * @returns {{month: string, hour: string, year: string, day: string, minute: string, second: string}}
 * @private
 */
const _getPartsOfDate = (date, config) => {
  const year = new Intl.DateTimeFormat('en', { year: config.year }).format(date);
  const month = new Intl.DateTimeFormat('en', { month: config.month }).format(date);
  const day = new Intl.DateTimeFormat('en', { day: config.day }).format(date);
  const hour = new Intl.DateTimeFormat('en', { hour: config.hour, hour12: false }).format(date);
  const minute = new Intl.DateTimeFormat('en', { minute: config.minute }).format(date);
  const second = new Intl.DateTimeFormat('en', { second: config.second }).format(date);
  return { year, month, day, hour, minute, second };
}

/**
 * @param pattern {string}
 * @param year {string}
 * @param month {string}
 * @param day {string}
 * @param hour {string}
 * @param minute {string}
 * @param second {string}
 * @returns {string}
 * @private
 */
const _fillDatePatternWithValues = (pattern, { year, month, day, hour, minute, second }) => {
  return pattern.replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hour)
    .replace('mm', String(minute).padStart(2, "0"))
    .replace('ss', String(second).padStart(2, "0"));
}
